module.exports = __webpack_public_path__ + "static/shepperd-fox-logo-blue-418b37abef06bfc02dec25d9a2e5c902.svg";